import { Time } from "@angular/common";

import { QuoteContact } from "./quote-contact";
import { QuoteHazmat } from "./quote-hazmat";
import { QuotePiece } from "./quote-piece";
import { ServiceLevel } from "../cfm-data/service-level";
import { QuoteRate } from "./quote-rate";

/**
 * This class is used to communicate quote information to/from the web service.
 */
export class Quote {

	public ShipID: number;

	public TagNumber: string;
	
	public ServiceLevel: ServiceLevel;

	public ContactName: string;

	public ContactEmail: string;

	public ContactPhone: string;
	
	public Shipper: QuoteContact;

	public Consignee: QuoteContact;

	public NumberPieces: number;

	public Weight: number;

	public WeightUOM: string;

	public DimUOM: string;

	public NumberSkids: number;

	public DeclaredValue: number;

	public CashOnDelivery: number;

	public DescriptionOfGoods: string;

	public SpecialInstructions: string;

	public Pieces: QuotePiece[];

	public Surcharges: QuoteRate[];

	public Hazmat: QuoteHazmat;

	public AutoGenerateHAWB: boolean;

	public HAWB: string;

	public ReferenceNumbers: string;

	public MAWB: string;
	
	public CustomerID: number;

	public PickupDate: Date;

	public PickupReadyTime: Time;

	public PickupCloseTime: Time;

	public DeliveryDate: Date;

}